import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { BookOpen, Eye, EyeOff } from "lucide-react";
import { adminApi, formatApiError } from "../../lib/api";

export default function AdminLogin() {
  const navigate = useNavigate();
  const [form, setForm] = useState({ email: "", password: "" });
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);
  const [show, setShow] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    if (form.password.length < 8) {
      setError("Password must be at least 8 characters.");
      return;
    }
    setLoading(true); setError("");
    try {
      const res = await adminApi.post("/auth/login", form);
      localStorage.setItem("bm_admin_token", res.token);
      navigate("/apadmin");
    } catch (err) {
      setError(formatApiError(err));
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen bg-[#F4F4F5] flex items-center justify-center px-4" data-testid="admin-login-page">
      <form onSubmit={submit} noValidate className="w-full max-w-sm bg-white border border-zinc-200 rounded-lg p-8" data-testid="admin-login-form">
        <div className="flex items-center gap-2 mb-8">
          <BookOpen className="w-6 h-6 text-zinc-900" />
          <span className="font-bold text-lg text-zinc-900">BookMala Staff</span>
        </div>
        <label className="block text-xs font-semibold text-zinc-500 mb-1.5">Email</label>
        <input type="email" required value={form.email} onChange={(e) => setForm({ ...form, email: e.target.value })}
          data-testid="admin-email-input" autoComplete="username"
          className="w-full border border-zinc-300 rounded-md px-3 py-2.5 text-sm mb-4 focus:outline-none focus:border-zinc-900" />
        <label className="block text-xs font-semibold text-zinc-500 mb-1.5">Password</label>
        <div className="relative mb-4">
          <input type={show ? "text" : "password"} value={form.password} onChange={(e) => setForm({ ...form, password: e.target.value })}
            data-testid="admin-password-input" autoComplete="current-password"
            className="w-full border border-zinc-300 rounded-md px-3 py-2.5 pr-10 text-sm focus:outline-none focus:border-zinc-900" />
          <button type="button" onClick={() => setShow(!show)} data-testid="admin-password-toggle" aria-label={show ? "Hide password" : "Show password"}
            className="absolute right-2.5 top-1/2 -translate-y-1/2 text-zinc-400 hover:text-zinc-900">
            {show ? <EyeOff className="w-4 h-4" /> : <Eye className="w-4 h-4" />}
          </button>
        </div>
        {error && <p className="text-sm text-red-600 mb-4" data-testid="admin-login-error">{error}</p>}
        <button type="submit" disabled={loading} data-testid="admin-login-submit"
          className="w-full bg-zinc-900 text-white font-semibold py-2.5 rounded-md hover:bg-zinc-700 transition-colors duration-150 disabled:opacity-60">
          {loading ? "Signing in..." : "Sign in"}
        </button>
      </form>
    </div>
  );
}
